import { render, staticRenderFns } from "./MoreList.vue?vue&type=template&id=4091d06c"
import script from "./MoreList.vue?vue&type=script&lang=js"
export * from "./MoreList.vue?vue&type=script&lang=js"
import style0 from "./MoreList.vue?vue&type=style&index=0&id=4091d06c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports